module.exports = require("@nestjs/config");